import { HttpErrorResponse } from '@angular/common/http';
import stringifyObject from 'stringify-object';
import { stringHelper } from './string-helper.class.js';

export interface IAngularErrorData {
	message: string;
	stacktrace: string | undefined;
}

export class AngularErrorHelper {
	extractErrorData(error: any): IAngularErrorData {
		let message: string = '';
		let stacktrace: string | undefined = undefined;

		if (error instanceof Error) {
			// standard error
			message = error.message.toString();
			stacktrace = error.stack;
		} else if (error instanceof HttpErrorResponse) {
			if (error.status === 401) {
				message = `Unauthorized access`;
			} else if (error.error?.message) {
				message = error.error.message;
			} else {
				message = stringifyObject(error.error);
			}
		} else if (stringHelper.isString(error)) {
			message = error.toString();
		} else if (typeof error === 'object') {
			// try parsing object
			try {
				message = stringifyObject(error);
			} catch {
				message = 'Parsing error failed. Original error: ' + message;
			}
		} else {
			message = 'Unexpected error: ' + message;
		}

		return {
			message: message,
			stacktrace: stacktrace
		};
	}
}

export const angularErrorHelper = new AngularErrorHelper();
